export const GA_MEASUREMENT_ID = "G-CL3DXYN2XL";

export const trackPageView = () => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href,
    send_to: GA_MEASUREMENT_ID,
  });
};

export const trackEvent = (eventName, params = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", eventName, { send_to: GA_MEASUREMENT_ID, ...params });
};

export const GOOGLE_ADS_ID = "AW-18500166616";
export const GOOGLE_ADS_LEAD_LABEL = "AW-18500166616/VJXTCKbb0ZQdENjHyPVE";

export const trackAdsConversion = (sendTo = GOOGLE_ADS_LEAD_LABEL, value = 1.0, currency = "USD") => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", { send_to: sendTo, value, currency });
};
